import ProductCard from '../cart/components/productCart';
import { ProductCardType } from './sider.types';
import { PreviewLayer } from '../../context/MapContext/MapProvider';
import React, { memo } from 'react';

export const ProductListing = memo(function ProductListing({
  sortedProducts,

  handleOnMouseEnterDraw,
  handleOnMouseLeaveRemove,
  handleOnClickPreviewImage,
  handleOnClickRemovePreviewImage,
  previewRefMap,
  previewLayer,
  polygonCoordinates,
  multiProduct,
}: {
  sortedProducts: ProductCardType[];
  handleOnMouseEnterDraw: Function;
  handleOnMouseLeaveRemove: Function;
  handleOnClickPreviewImage: (
    coordinates: number[][][],
    intersectionCoordinates: number[][][] | null,
    bbox: number[],
    url: string,
    area: number,
    id: string
  ) => void;
  handleOnClickRemovePreviewImage: Function;
  previewRefMap: React.MutableRefObject<any>;

  previewLayer: PreviewLayer;
  polygonCoordinates: number[][][];
  multiProduct: boolean;
}) {
  return sortedProducts.length > 0
    ? sortedProducts.map((product, index) => {
        return (
          <ProductCard
            key={index}
            cardData={product}
            handleOnMouseEnterDraw={handleOnMouseEnterDraw}
            handleOnMouseLeaveRemove={handleOnMouseLeaveRemove}
            handleOnClickPreviewImage={handleOnClickPreviewImage}
            handleOnClickRemovePreviewImage={handleOnClickRemovePreviewImage}
            previewRefMap={previewRefMap}
            previewLayer={previewLayer}
            polygonCoordinates={polygonCoordinates}
            multiProduct={multiProduct}
          />
        );
      })
    : null;
});
